import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { AuthProvider } from './context/auth'
import customTheme from "./customTheme";
import AppRoutes from "./AppRoutes";
import i18n from './i18n';
import './assets/styles.css';
import './styles/ziframed-design-system.css';

const queryClient = new QueryClient()

export default function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <ChakraProvider theme={customTheme}>
            <Router>
              <AuthProvider>
                <AppRoutes />
              </AuthProvider>
            </Router>
          </ChakraProvider>
        </I18nextProvider>
      </QueryClientProvider>
    </div>
  )
};
